import { computed, type Signal } from "@angular/core";
import type {
    WkDataTableColumnDefinition,
    WkDataTableCellValue,
    DynamicColumns,
    WkDataTableColumnBaseDefinition,
} from "@components/data-table/data-table.types";
import { WkDataTableSimpleColumn } from "./data-table-simple-column";
import { WkDataTableColumn } from "./data-table-column";

export abstract class WkDataTableDynamicColumn<
    TItem,
    TValue extends WkDataTableCellValue,
    TSortValue extends WkDataTableCellValue = TValue,
    TColumnDefinition extends WkDataTableColumnDefinition = WkDataTableColumnDefinition,
> extends WkDataTableColumn<WkDataTableColumnBaseDefinition> {
    protected columnsCached: Map<string, WkDataTableSimpleColumn<TItem, TValue, TSortValue, TColumnDefinition>> = new Map();
    protected abstract columnsByName: Signal<DynamicColumns<TItem, TValue, TSortValue, TColumnDefinition>>;
    public columns = computed(() => Array.from(this.columnsByName().values()));
}
